import { Observable } from 'rxjs'

export class LogoDetails {

    title: string;
    description: string;
    displayDesktopBackgroundColour: boolean;

    getUrl: () => Observable<string>;
    uploadLogo: (files: any) => Observable<void>;

    constructor(
        title: string,
        description: string,
        displayDesktopBackgroundColour: boolean,
        getUrl: () => Observable<string>,
        uploadLogo: (files: any) => Observable<void>)
    {
        this.title = title;
        this.description = description;
        this.displayDesktopBackgroundColour = displayDesktopBackgroundColour;

        this.getUrl = getUrl;
        this.uploadLogo = uploadLogo;
    }
}